import posthog from 'posthog-js';

if (window.pnEnv && window.pnEnv.POSTHOG_API_KEY) {
  posthog.init(window.pnEnv.POSTHOG_API_KEY, {
    api_host: 'https://us.i.posthog.com',
    defaults: '2025-11-30',
  });

  posthog.register({
    source: 'eternal-sledgehammer',
    environment: window.pnEnv.RAILS_ENV,
  });

  if (window.pnEnv.CURRENT_USER && window.pnEnv.CURRENT_USER.email) {
    posthog.identify(window.pnEnv.CURRENT_USER.email, {
      full_name: window.pnEnv.CURRENT_USER.full_name,
    });
  }

  // Handle logout - reset PostHog when user signs out
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href*="destroy_user_session"]');
    if (link) {
      posthog.reset();
    }
  });
}
